<template>
    <div >
      <b-modal v-if="!this.recNo"
        id="PatientActivity" 
        size="md" 
        scrollable 
        centered 
        :title="this.$t('ActList.Activities')" 
        :visible="true"
        :hide-header-close="true"
        :no-close-on-backdrop="true" 
        @ok="onClickShowReport" 
        @cancel="onClickClose"
        :cancel-title="$t('Shared.BtnCancel')">
        <b-row>
          <b-col lg="6" md="6" sm="6">
             <MdDateTime 
                  :Label="$t('Shared.datefrom')" 
                  :Model="dateFrom"                           
                  @input="dateFrom = $event"                            
                  :Id="'PatientActivitiesReportDateFrom'"
                  :Type="'date'"                  
                  :isRequired="false"                           
                  :isConfirm="false"
                  :ReadOnly="false"
                  v-bind:isValid="isDateFromValid">
              </MdDateTime>
          </b-col>
          <b-col lg="6" md="6" sm="6">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'PatientActivitiesReportDateTo'"
              :Type="'date'"            
              :isRequired="false"                           
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="isDateToValid">
          </MdDateTime>
          </b-col>
        </b-row>
      </b-modal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="this.$t('ActList.Activities')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportPatientActivities"
          :ReportName="'PatientActivities'"
          :ReportTitle="this.$t('ActList.Activities')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import Utils from '../../../common/utils'

    export default Vue.extend({
        name: "PatientActivitiesRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          patientCode: String,
          closeWindow: Function,
          patientName: String,
          recNo: [String, Number],
          patientDob: String,
          userName: String
        },
        data() {
            return {
                isReportVisible: false,
                dateFrom: '',
                dateTo: '',
                reportParams: [],
                isDateFromValid: true,
                isDateToValid: true,
            }
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.closeWindow()
            },

            onClickClose() {
              this.closeWindow()
            },

            onClickShowReport(event) {
                // Prevenir el cierre del modal
              if (event && event.preventDefault) {
                event.preventDefault();
              }
              
              // Si la validación falla, no continuar y mantener el modal abierto
              if (!this.recNo) {
                if (!this.validateForm()) {
                  return; // Salir sin cerrar el modal
                }
              }
              this.reportParams = []
              this.reportParams.push({ paramName: 'startDate', paramValue: this.dateFrom})
              this.reportParams.push({ paramName: 'endDate', paramValue: this.dateTo})
              this.reportParams.push({ paramName: 'patientCode', paramValue: this.patientCode})
              this.reportParams.push({ paramName: 'patientName', paramValue: this.patientName})
              this.reportParams.push({ paramName: 'recNo', paramValue: this.recNo})
              this.reportParams.push({ paramName: 'patientDob', paramValue: this.patientDob})
              this.reportParams.push({ paramName: 'IsAlert', paramValue: false})
              this.reportParams.push({ paramName: 'userName', paramValue: this.userName})

              this.isReportVisible = true
              this.$refs.reportPatientActivities.buildDocument(this.reportParams)
            },

            validate_date_range() {
              return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
            },

            // Método de validación reutilizable
            validateForm() {
              const isValid = this.validate_date_range();
        
              this.isDateFromValid = isValid;
              this.isDateToValid = isValid;
              
              // Forzar actualización del componente
              this.$forceUpdate();
              
              if (!isValid) {
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
                return false;
              }
              return true;
            },
        },
        
        mounted () {
          if (this.recNo)
           this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
